<template>
  <div>
    <div
      class="font-weight-bold text-cello d-flex align-items-center justify-content-between"
    >
      Producer
      <el-input
        v-model="businesses_search"
        class="w-50"
        size="mini"
        placeholder="Search producer"
      ></el-input>
    </div>
    <div
      style="height: 250px; overflow-y: auto; overflow-x: hidden"
      class="mt-1 shadow-sm p-2 bg-white rounded"
    >
      <el-checkbox-group
        v-model="business_ids"
        @change="$emit('businessIds', business_ids)"
        class="row"
      >
        <el-checkbox
          class="col-lg-6 col-md-12 col-sm-12 m-0"
          v-for="business in businesses.filter(
            (data) =>
              !businesses_search ||
              data.name.toLowerCase().includes(businesses_search.toLowerCase()),
          )"
          :key="business.id"
          :label="business.id"
          >{{ business.name }}</el-checkbox
        >
      </el-checkbox-group>
      <p class="mt-2" v-if="businesses_loading">Loading...</p>
    </div>
  </div>
</template>

<script>
import Business from "../modelsPortal/Business";
export default {
  props: {
    clearChild: {
      type: Number,
    },
  },
  data() {
    return {
      businesses: [],
      businesses_loading: false,
      businesses_search: "",
      business_ids: [],
    };
  },
  watch: {
    clearChild: function (newVal, oldVal) {
      this.clear();
    },
  },
  created() {
    this.getBusinesses();
  },
  mounted() {},
  methods: {
    clear() {
      this.business_ids = [];
    },
    getBusinesses() {
      this.businesses_loading = true;
      Business.params({ no_paginate: true })
        .select("id", "name")
        .orderBy("name")
        .get()
        .then((res) => {
          this.businesses = res;
          this.businesses_loading = false;
        })
        .catch((errors) => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
  },
};
</script>
